import * as css from './ItemIcon.css';
function ItemIcon({text,icon,onClick}) {

    return (
        <css.item $icon={icon} onClick={onClick}>{text}</css.item>
    );
}

export default ItemIcon;
